import { render, staticRenderFns } from "./FormulaInfo.vue?vue&type=template&id=015896d7&scoped=true&"
import script from "./FormulaInfo.vue?vue&type=script&lang=js&"
export * from "./FormulaInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormulaInfo.vue?vue&type=style&index=0&id=015896d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015896d7",
  null
  
)

export default component.exports